<template>
  <div>
    <div v-if="meetups.length>0">
      <div  class="meetup-detail-tab" v-for="item in meetups" :key="item.sli_id" :class="isupcoming?'':'past'">
        <div class="meetup-detail-date-div" :class="isupcoming?'upcoming':'past'">
          <div class="meetup-icon" >
            <img class="calendar-meetup" :src="(isupcoming)?imgIconCalendarUpComing:imgIconCalendarPast" alt="..."/>
          </div>
          <div class="meetup-date-day"> {{getDay(item.sli_startat)}} </div>
          <div class="meetup-date-month">{{ $t('sl.calendar.months.'+getMonth(item.sli_startat))}}</div>
          <div class="meetup-date-year">{{ getYear(item.sli_startat) }}</div>
        </div>
        <div class="meetup-detail-title-div sl-meetup-detail-with-separation">
          <tooltip-info v-if="item.servicelinelangs[0].sll_description!==null" :title="item.servicelinelangs[0].sll_title" :description="item.servicelinelangs[0].sll_description">
          <div class="meetup-icon information" >
            <img class="calendar-meetup info" :src="(isupcoming)?imgIconInfoUpcoming:imgIconInfoPast" alt="..."/>
          </div>
          </tooltip-info>
          <div v-else class="meetup-icon" >
            <img class="calendar-meetup info" :src="(isupcoming)?imgIconInfoUpcoming:imgIconInfoPast" alt="..."/>
          </div>
          <div class="text-detail">{{item.servicelinelangs[0].sll_title }}</div>
        </div>
        <div class="meetup-detail-speaker-div sl-meetup-detail-with-separation">
          <div class="meetup-icon" >
            <img class="calendar-meetup" :src="(isupcoming)?imgIconPeopleUpcoming:imgIconPeoplePast" alt="..."/>
          </div>
          <div class="text-detail">{{item.sli_speakers }}</div>
        </div>
        <div class="meetup-detail-level-div sl-meetup-detail-with-separation sl-meetup-detail-center"  >
          <div class="meetup-icon" >
            <img v-if="item.sli_accesslevel=='1'" class="calendar-meetup-state" :src="(isupcoming)?imgState1:imgState1Past" alt="..."/>
            <img v-if="item.sli_accesslevel=='2'" class="calendar-meetup-state" :src="(isupcoming)?imgState2:imgState2Past" alt="..."/>
            <img v-if="item.sli_accesslevel=='3'" class="calendar-meetup-state" :src="(isupcoming)?imgState3:imgState3Past" alt="..."/>
          </div>
          <div>{{ $t('sl.optionsAccess.'+item.sli_accesslevel) }}</div>
        </div>
        <div class="meetup-detail-play-div sl-meetup-detail-with-separation " v-if="isupcoming">
          <div v-if="isTeams(item.sli_startat)" class="sl-meetup-detail-center">
            <el-tooltip placement="bottom" :content="$t('tooltip.connecttoteams')">
              <div class="meetup-detail-play-div-content teams">
                <a :href="item.sli_teamslink" target="_blank">
                <img class="meetup-icon-play" :src="teams" alt="..."/>
                </a>
              </div>
            </el-tooltip>
          </div>
          <div v-else class="sl-meetup-detail-center">
            <el-tooltip placement="bottom" :content="$t('tooltip.addtoagenda')">
              <div class="meetup-detail-play-div-content calendar">
                <a :href="item.sli_calendarlink" target="_blank">
                  <img class="meetup-icon-play" :src="calendarPlus" alt="..."/>
                </a>
              </div>
            </el-tooltip>
          </div>
        </div>
        <div v-else class="meetup-detail-play-div sl-meetup-detail-with-separation " >
          <div class="sl-meetup-detail-center" >
              <el-tooltip placement="bottom" :content="$t('tooltip.seereplay')">
                <div v-if="item.sli_streamlink !== '' && item.sli_streamlink !== null" class="meetup-detail-play-div-content replay">
                  <!-- <a :href="item.sli_streamlink" target="_blank">
                    <img class="meetup-icon-replay" :src="play" alt="..."/>
                  </a> -->
                  <a href="javascript:void(0)" @click="openToStreamViewer(item.sli_id)">
                    <img class="meetup-icon-replay" :src="play" alt="..."/>
                  </a>
                </div>
                <div v-else class="meetup-detail-play-div-content replaynotdispo">
                  <img class="meetup-icon-replay" :src="playNotDispo" alt="..."/>
                </div>
              </el-tooltip>
          </div>
          <!-- <a :href="item.sli_streamlink">
          <div class="meetup-text-replay sl-meetup-detail-center">
              {{ $t('sl.seereplay') }}
          </div>
          </a> -->
        </div>
        <!--
          <div class="sl-meetup-detail-center sl-meetup-detail-with-separation">
            <div class="meetup-detail-icon-type">
              <img v-if="item.slt_id=='1'" class="meetup-icon-type" :src="itDigitalExperience" alt="..."/>
              <img v-if="item.slt_id=='2'" class="meetup-icon-type" :src="infrastructureCyberSecurity" alt="..."/>
              <img v-if="item.slt_id=='3'" class="meetup-icon-type" :src="dataAndAI" alt="..."/>
              <img v-if="item.slt_id=='4'" class="meetup-icon-type" :src="intelligentSystems" alt="..."/>
              <img v-if="item.slt_id=='5'" class="meetup-icon-type" :src="productProcessEngineering" alt="..."/>
            </div>
          </div>
        -->
      </div>
      <div>
        <b-modal id="sli-stream" size="xl" centered v-model="modalStreamVisible" :title="title" button-size="sm" hide-footer header-class="video-header" body-class="video-body" @shown="adjustThumbnailListHeight">
          <b-row class="text-center m-0 p-3" align-v="center">
            <b-col sm="9" align-self="center" class="p-0">
              <video :lang="lang" v-if="!videoError" ref="videoPlayer" width="100%" controls controlslist="nodownload noremoteplayback noplaybackrate" preload="metadata" @error="handleVideoError" @enterpictureinpicture="handlePipEnter" @leavepictureinpicture="handlePipLeave" @play="handlePlay" @pause="handlePause" :key="videoKey" :poster="poster">
                <source :src="track" type="video/mp4" />
                <track v-if="trackSrcFr" :label="$t('generic.version-fr')" kind="subtitles" srclang="fr" :src="trackSrcFr" default>
                <track v-if="trackSrcEn" :label="$t('generic.version-en')" kind="subtitles" srclang="en" :src="trackSrcEn">          
              </video>
              <div class="play-icon" v-if="showPlayIcon" @click="toggleVideo">
                <!-- Icône de lecture (vous pouvez remplacer par votre propre icône) -->
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="-2 1 22 22" fill="currentColor">
                  <path d="M3 22v-20l18 10-18 10z"/>
                </svg>
              </div>              
            </b-col>
            <b-col sm="3" align-self="center" class="p-0">
              <div class="thumbnail-list pl-4 pr-4" style="max-height: 0;" ref="thumbnailColumn">
                <div v-for="(video, index) in playlist" :key="index" class="thumbnail-item">
                  <img :src="video.sli_thumbnail?`${apiUrl}servicelines/thumbnail/${video.sli_thumbnail}?q=${token}`:'img/icons/sl/content/calendar-grey.png'" alt="Thumbnail" @click="playVideo(video)" @error="handleImageError(video)">
                  <div class="title">{{ video.servicelinelangs[0].sll_title }}</div>
                  <div class="speakers">{{ video.sli_speakers }}</div>
                </div>
              </div>
            </b-col>
          </b-row>
          <!--
          <b-embed
            type="iframe"
            aspect="16by9"
            src="https://www.youtube.com/embed/zpOULjyy-n8?rel=0"
            allowfullscreen
          ></b-embed>
          -->
          <div v-if="videoError" class="video-error-message">
            <b-row class="text-center py-5" align-v="center">
              <b-col sm="12" align-self="center">
                <span class="error">
                  ☹{{ $t('generic.stream-not-found') }}
                </span>
                <br/>
                <span class="error-more">{{ $t('generic.stream-not-supported') }}</span>
              </b-col>
            </b-row>
          </div>

        </b-modal>
      </div>        
    </div>
    <div v-else class="meetup-detail-tab no-meetup" >{{ $t('sl.nomeetup') }}</div>
  </div>
</template>

<script>
  import TooltipInfo from '@/components/ServiceLines/TooltipInfo';
  import Vue from 'vue';
  import Vuetify from 'vuetify';
  import { BButton, BModal } from 'bootstrap-vue';
  import { mapActions } from "vuex";
  import 'bootstrap/dist/css/bootstrap.css';
  import 'bootstrap-vue/dist/bootstrap-vue.css';
  import { isVideoUrl } from '@/util/tools';

  Vue.use(Vuetify);
  export default {
    name: 'meetup-details',
    components: {
      'tooltip-info': TooltipInfo,
      BButton,
      BModal
    },
    data() {
      return {
        token: localStorage.getItem(Vue.Keys.TOKEN),
        apiUrl: process.env.VUE_APP_APIURL,
        lang: Vue.i18n.locale(),
        modalStreamVisible: false,
        trackSrcFr: null,
        trackSrcEn: null,
        track: null,
        poster: null,
        title: null,
        isPipActive: false,
        videoError: false,
        playlist: [],
        videoKey: 0,
        showPlayIcon: true 
      }
    },
    props: {
        meetups:[],
        all: [],
        type: null,
        isupcoming:Boolean,
        imgIconCalendarUpComing: {
            type: String,
            default: 'img/icons/sl/content/calendar-green.png'
        },
        imgIconCalendarPast:{
            type: String,
            default: 'img/icons/sl/content/calendar-grey.png'
        },
        imgIconInfoUpcoming:{
            type: String,
            default: 'img/icons/sl/content/info-black.png'
        },
        imgIconInfoPast:{
            type: String,
            default: 'img/icons/sl/content/info-grey.png'
        },
        imgIconPeopleUpcoming:{
            type: String,
            default: 'img/icons/sl/content/people-black.png'
        },
        imgIconPeoplePast:{
            type: String,
            default: 'img/icons/sl/content/people-grey.png'
        },
        imgIconTimeUpcoming:{
            type: String,
            default: 'img/icons/sl/content/time-black.png'
        },
        imgIconTimePast:{
            type: String,
            default: 'img/icons/sl/content/time-grey.png'
        },
        imgState1:{
            type: String,
            default: 'img/icons/sl/content/state-1.png'
        },
        imgState1Past:{
            type: String,
            default: 'img/icons/sl/content/state-1-grey.png'
        },
        imgState2:{
            type: String,
            default: 'img/icons/sl/content/state-2.png'
        },
        imgState2Past:{
            type: String,
            default: 'img/icons/sl/content/state-2-grey.png'
        },
        imgState3:{
            type: String,
            default: 'img/icons/sl/content/state-3.png'
        },
        imgState3Past:{
            type: String,
            default: 'img/icons/sl/content/state-3-grey.png'
        },
        teams:{
            type: String,
            default: 'img/icons/sl/content/teams.png'
        },
        calendarPlus:{
            type: String,
            default: 'img/icons/sl/content/calendar-plus.png'
        },
        play:{
            type: String,
            default: 'img/icons/sl/content/play.png'
        },
        playNotDispo:{
            type: String,
            default: 'img/icons/sl/content/play-grey.png'
        },
        itDigitalExperience:{
            type: String,
            default: '/img/icons/sl/IT_digital_black.png'
        },
        infrastructureCyberSecurity:{
            type: String,
            default: '/img/icons/sl/infrastructure_cyber_security_black.png'
        },
        dataAndAI:{
            type: String,
            default: '/img/icons/sl/data_AI_black.png'
        },
        intelligentSystems:{
            type: String,
            default: '/img/icons/sl/intelligent_systems_black.png'
        },
        productProcessEngineering:{
            type: String,
            default: '/img/icons/sl/product_process_engineering_black.png'
        }
    },
    methods: {
      ...mapActions(["GetServiceLine"]),
      
      getDay(stringDate){
            let response="";
            if(stringDate!="" && stringDate!=null && stringDate!=undefined ){
              response = stringDate.toString().substring(8,10);
            }
            return response;
      },
      getMonth(stringDate){
            let response="0";
            if(stringDate!="" && stringDate!=null && stringDate!=undefined ){
              response = parseInt(stringDate.toString().substring(5,7));
            }
            return response;
      },
      getYear(stringDate) {
          let response = "0";
          if (stringDate !== "" && stringDate !== null && stringDate !== undefined) {
              response = parseInt(stringDate.toString().substring(0, 4));
          }
          return response;
      },
      convertToDate(stringDate){
                const sYear=stringDate.toString().substring(0, 4);
                const sMonth=stringDate.toString().substring(5,7);
                const sDay=stringDate.toString().substring(8,10);
                const sH=stringDate.toString().substring(11,13);
                const sM=stringDate.toString().substring(14,16);
                return new Date(sYear, sMonth-1, sDay,sH,sM,0);
      },     
      isTeams(dateMeetup){
        let dMeetup=this.convertToDate(dateMeetup);
        let difference=dMeetup-new Date();
        return difference < 300000;
      },
      openToStreamViewer(id) {
        // let token = localStorage.getItem(Vue.Keys.TOKEN);
        // this.GetServiceLine(id)
        //   .then(
        //     data => {
        //       console.log(data);
        //       this.trackSrcFr = data.servicelinelangs[0].vtt != null?`data:text/vtt;base64,${data.servicelinelangs[0].vtt}` : null;
        //       this.trackSrcEn = data.servicelinelangs[1].vtt != null ? `data:text/vtt;base64,${data.servicelinelangs[1].vtt}` : null;
        //       var d = new Date();
        //       this.track = `${this.apiUrl}${data.sli_streamlink}?q=${token}&${d.getTime()}`;
        //       this.poster = data.sli_thumbnail ? `${this.apiUrl}servicelines/thumbnail/${data.sli_thumbnail}?q=${token}` : 'img/icons/sl/content/calendar-grey.png';
        //       this.title = data.servicelinelangs.find(x => x.lan_code == this.lang).sll_title;
        //       this.modalStreamVisible = true;

        //       //Playlist
        //       this.playlist = this.all.filter(m => m.slt_id == data.slt_id);
        //     }
        // )
        // .catch(
        //   error => console.log(error)
        // )
        // Utilisation de $router.push pour rediriger l'utilisateur

        //PR-2024 - new page
        this.$router.push(`/play?id=${id}&from=${this.$route.path.substring(1)}`);
      },
      checkVideoUrl(url) {
        return isVideoUrl(url);
      },
      // togglePip() {
      //   const video = this.$refs.videoPlayer;
      //   if (this.isPipActive) {
      //     document.exitPictureInPicture().catch(error => {
      //       console.error('Failed to exit Picture-in-Picture mode:', error);
      //     });
      //   } else {
      //     video.requestPictureInPicture().catch(error => {
      //       console.error('Failed to enter Picture-in-Picture mode:', error);
      //     });
      //   }
      // },
      handlePipEnter() {
        this.isPipActive = true;
        this.modalStreamVisible = false;
      },
      handlePipLeave() {
        this.isPipActive = false;
        this.modalStreamVisible = true;
      },
      handleVideoError() {
        this.videoError = true;
      },
      handleImageError(video) {
        video.thumbnailUrl = "img/icons/sl/content/calendar-grey.png";
      },
      playVideo(item) {
        this.track = `${this.apiUrl}${item.sli_streamlink}?q=${this.token}&${(new Date()).getTime()}`;
        this.poster = item.sli_thumbnail ? `${this.apiUrl}servicelines/thumbnail/${item.sli_thumbnail}?q=${this.token}` : 'img/icons/sl/content/calendar-grey.png';
        this.videoKey++;
        setTimeout(() => {
          this.adjustThumbnailListHeight();
        }, 50);
      },
      adjustThumbnailListHeight() {
        const modalHeight = this.$refs.videoPlayer.clientHeight;
        this.$refs.thumbnailColumn.style.maxHeight = `${modalHeight}px`;
      },
      handlePlay() {
        this.showPlayIcon = false;
        setTimeout(() => {
          this.adjustThumbnailListHeight();
        }, 50);
      },
      handleClick() {
        setTimeout(() => {
          this.adjustThumbnailListHeight();
        }, 50);
      },
      handlePause() {
        this.showPlayIcon = true;
      },
      toggleVideo() {
        const videoElement = this.$refs.videoPlayer;
        if (videoElement.paused) {
          videoElement.play();
          this.showPlayIcon = false;
        } else {
          videoElement.pause();
          this.showPlayIcon = true;
        }
      }       
    }
  };
</script>
